import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay, faCheck, faPhone } from "@fortawesome/free-solid-svg-icons";
import "../../../Styles/Redirecting Styles/NavbarStyles/mobile.css";
import Shape2 from "../../../assets/brand/choose-shape-2.png";
import ModalVideo from "react-modal-video";
import "react-modal-video/scss/modal-video.scss";
import { Helmet } from "react-helmet";
import CanadaHeader1 from "../../Components/seperate Components/CanadaHeader1";
import CanadaFooter from "../../Components/Footer";
import section1 from "../../../assets/canada/Mobile Apps Development/mobile-sec-1-1.jpg";
import section2 from "../../../assets/canada/Mobile Apps Development/mobile-sec-1-2.jpg";
import section3 from "../../../assets/canada/Mobile Apps Development/mobile-sec-1-3.jpg";
import section4 from "../../../assets/canada/Mobile Apps Development/passionate-team.jpg";

const CanadaMobileApp = () => {
  const [isOpen, setOpen] = useState(false);

  return (
    <div>
      <Helmet>
        <title>
          Top Mobile App Development Company in Canada | Zithas Technologies
        </title>
        <meta
          name="description"
          content="
          Elevate your business with top mobile app development services in Canada. We're the leading mobile app development company for your success."
        />
        <meta
          name="keywords"
          content="mobile app development in canada, mobile app development company in canada, mobile app development canada, top mobile app development company in canada, app development canada, app development services in canada, top mobile app company canada"
        />
      </Helmet>

      <CanadaHeader1 />

      {/* Banner section */}
      <div
        className="bd-page-title-area bd-page-title-bg4 pt-220 pb-155"
        style={{ height: "380px" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div
                className="bd-page-title text-center z-index"
                style={{ bottom: "45px" }}
              >
                <h2 className="breadcrumb-title1 mobile-main-title">
                  Crafting Mobile Apps
                </h2>
                <div className="breadcrumb-menu">
                  <nav className="breadcrumb-trail breadcrumbs">
                    <p style={{ color: "black" }}>
                      Harness the potential of mobile technology to empower your
                      business and unlock its true capabilities.
                    </p>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* First Section */}
      <section className="bd-choose-area fix pb-50 pt-80">
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="bd-choose-shape">
            <div className="row " style={{ alignItems: "center" }}>
              <div className="col-xl-6 col-lg-6 order-2 order-lg-1 pr-20">
                <div className="bd-choose-text mb-30 z-index">
                  <div className="bd-section-title-wrapper mb-25">
                    {/* <h5 className="bd-section-subtitle mb-15">Why Choose Us</h5> */}
                    <h2 className="bd-section-title mb-15 first-mobile-tittle">
                      Maximize Business Potential with <br />
                      <span style={{ color: "#ffbf1e" }}>
                        {" "}
                        Mobile Application
                      </span>
                    </h2>
                  </div>

                  <p
                    className="mb-20"
                    style={{ width: "95%", fontSize: "18px" }}
                  >
                    Unlock your business's potential with our mobile app
                    development services. We understand the significance of a
                    user-friendly mobile presence. Our team translates your
                    vision into an engaging app. Whether expanding reach,
                    streamlining processes, or innovating, our apps make an
                    impact.
                  </p>
                  <p className="mb-20" style={{ fontSize: "18px" }}>
                    At Zithas, we prioritize user-centric design, seamless
                    functionality, and robust security, ensuring that your app
                    not only meets but exceeds your expectations. With our
                    extensive industry experience, we deliver customized
                    solutions that cater to your specific needs. Let us be your
                    technology partner in harnessing the power of mobile to
                    drive growth, boost efficiency, and enhance customer
                    satisfaction.
                  </p>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 order-1 order-lg-2">
                <div className="bd-choose-img text-end  z-index">
                  <div className="row align-items-center custom-mar-15 top-resp">
                    <div className="col-xl-6 col-lg-6 col-6 custom-pad-15">
                      <div className="bd-choose-img-inner mb-15 bd-choose-img-inner-1">
                        <img
                          src={section1}
                          className="bordertop-img1"
                          alt="img not found"
                        />
                      </div>
                    </div>
                    <div className="col-xl-6 col-lg-6 col-6 custom-pad-15">
                      <div className="bd-choose-img-inner mb-15">
                        <img
                          src={section2}
                          className="bordertop-img2"
                          alt="img not found"
                        />
                      </div>
                      <div className="bd-choose-img-inner mb-15">
                        <img
                          src={section3}
                          className="bordertop-img3"
                          alt="img not found"
                        />
                      </div>
                    </div>
                  </div>
                  <img
                    className="bd-choose-shape bd-choose-shape-2"
                    src={Shape2}
                    alt="shape img not found"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <ModalVideo autoplay isOpen={isOpen} channel='youtube' videoId='u-2jURch9-4' onClose={() => setOpen(false)}>
                </ModalVideo>
                <button className="btn btn responsive_digital first_pop_mobile" onClick={() => setOpen(true)}>
                    <FontAwesomeIcon icon={faPlay} className="play_bt_vid play_transition" />
                </button> */}
      </section>

      {/* Secound section*/}
      <section className="bd-choose-area  fix">
        <div className="container" style={{ maxWidth: "1300px" }}>
          <div className="bd-choose-shape">
            <div className="row second-mobile-responsive">
              <div className="col-xl-6 col-lg-6 order-2 order-lg-1 second-mobile-section1">
                {/* <div className="ablog ablog-4 mb-60"> */}
                <h2 className="bd-section-title mb-10 ml-15 four-point-tittle">
                  Transform Your Business Operations to a New Level.
                </h2>
                <div className="bd-choose-text z-index">
                  <div className="bd-section-title-wrapper">
                    <p className="ml-25 mobile-para1">
                      Elevate your business operations to unprecedented heights
                      with our cutting-edge solutions at Zithas Technologies.
                      Our expertise in redefining operational strategies is a
                      game-changer for organizations seeking unparalleled
                      success. We believe in the power of tailored
                      transformation, understanding that each business has
                      unique needs.{" "}
                    </p>
                  </div>
                  <div></div>
                </div>
                {/* </div> */}
              </div>
              <div className="col-xl-6 col-lg-6 order-1 order-lg-2 mt-0 second-mobile-section2">
                <div className="bd-choose-img mb-30 z-index">
                  <div className="bd-choose-info-wrapper">
                    <div className="container">
                      <div className="row mb-50 mobile">
                        <div className="col four-section mr-50">
                          <div className="animate-hover">
                            <div className="bd-choose-info-icon mb-15">
                              <i>
                                <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440751/website/icons/billboard-64_d0rued.png" />
                              </i>
                            </div>
                            <div className="bd-choose-info-text">
                              <h2
                                className="bd-choose-info-title mb-15"
                                style={{ color: "#5e5858" }}
                              >
                                Increased Brand Awareness
                              </h2>
                            </div>
                          </div>
                        </div>
                        <div className="col">
                          <div className="animate-hover">
                            <div className="bd-choose-info-icon mb-15">
                              <i>
                                <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440751/website/icons/business-64_qauov3.png" />
                              </i>
                            </div>
                            <div className="bd-choose-info-text">
                              <h2
                                className="bd-choose-info-title mb-15"
                                style={{ color: "#5e5858" }}
                              >
                                Higher Business Engagement Level{" "}
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row ml-15 phone text-center">
                      <div className="col four-section2 mr-50">
                        <div className="animate-hover">
                          <div className="bd-choose-info-icon mb-15">
                            <i>
                              <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440751/website/icons/communication-64_suewof.png" />
                            </i>
                          </div>
                          <div className="bd-choose-info-text">
                            <h2
                              className="bd-choose-info-title mb-15"
                              style={{ color: "#5e5858" }}
                            >
                              Direct Communication Options
                            </h2>
                          </div>
                        </div>
                      </div>
                      <div className="col">
                        <div className="animate-hover">
                          <div className="bd-choose-info-icon mb-15">
                            <i>
                              <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440751/website/icons/revenue-64_yqhgif.png" />
                            </i>
                          </div>
                          <div className="bd-choose-info-text">
                            <h2
                              className="bd-choose-info-title mb-15"
                              style={{ color: "#5e5858" }}
                            >
                              Boosting Sales & Revenues
                            </h2>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Third Section */}

      <section className="bd-about-six-area  pt-80">
        <div className="container" style={{ maxWidth: "1270px" }}>
          <h2 className="bd-section-title mb-20 third-mobile-tittle">
            Drive Business Efficiency with the Right
            <span style={{ color: "#ffbf1e" }}> Mobile Application. </span>
          </h2>

          <ul style={{ color: "black", fontSize: "20px", listStyle: "none" }}>
            <li>
              Mobile application development involves a series of stages,
              including design, development, testing, and launch. The type of
              mobile app can vary, spanning from native apps to hybrid apps,
              contingent upon its design approach.
            </li>
          </ul>
          <div
            className="bd-service service-mobile mb-30 mt-30"
            style={{ backgroundColor: "var(--clr-bg-gray)" }}
          >
            <div className="row third-mobile-section1">
              <div className="col-lg-6 mobile-subpoint-section">
                <h4 style={{ fontWeight: "600" }}>Native Mobile Application</h4>
                <div className="bd-about-six-text">
                  <div className="bd-section-title-wrapper mb-25">
                    <p style={{ fontSize: "18px", lineHeight: "1.75" }}>
                      Native applications are smartphone software designed
                      explicitly for individual mobile operating systems, such
                      as Swift for iOS and Java or Kotlin for Android. These
                      apps are finely tuned to function solely within their
                      dedicated platforms and are not compatible with
                      alternative systems. Native software receives regular
                      updates via the App Store or Google Play Store, ensuring
                      an ongoing stream of enhancements and advancements.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-8 mobile-subpoint-section ">
                <div className="bd-about-six-img">
                  <div className="bd-about-six-feature six-feature-mobile pl-120">
                    <h4 className="mb-15" style={{ fontWeight: "600" }}>
                      Key Features
                    </h4>
                    <ul className="">
                      <li
                        className="d-flex align-items-center"
                        style={{
                          fontSize: "18px",
                          color: "var(--clr-body-text)",
                        }}
                      >
                        <i>
                          <FontAwesomeIcon icon={faCheck} />
                        </i>{" "}
                        Quickly available through home screen shortcuts
                      </li>
                      <li
                        className="d-flex align-items-center"
                        style={{
                          fontSize: "18px",
                          color: "var(--clr-body-text)",
                        }}
                      >
                        <i>
                          <FontAwesomeIcon icon={faCheck} />
                        </i>{" "}
                        Offers a quick and dependable user journey
                      </li>
                      <li
                        className="d-flex align-items-center"
                        style={{
                          fontSize: "18px",
                          color: "var(--clr-body-text)",
                        }}
                      >
                        <i>
                          <FontAwesomeIcon icon={faCheck} />
                        </i>{" "}
                        Maximizes the potential of various mobile
                        functionalities
                      </li>
                      <li
                        className="d-flex align-items-center"
                        style={{
                          fontSize: "18px",
                          color: "var(--clr-body-text)",
                        }}
                      >
                        <i>
                          <FontAwesomeIcon icon={faCheck} />
                        </i>{" "}
                        Operates seamlessly when offline
                      </li>
                      <li
                        className="d-flex align-items-center"
                        style={{
                          fontSize: "18px",
                          color: "var(--clr-body-text)",
                        }}
                      >
                        <i>
                          <FontAwesomeIcon icon={faCheck} />
                        </i>
                        Tends to have fewer glitches and flaws
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="bd-service mb-30 service-mobile"
            style={{ backgroundColor: "var(--clr-bg-gray)" }}
          >
            <div className="row third-mobile-section1">
              <div className="col-lg-6 mobile-subpoint-section">
                <h4 style={{ fontWeight: "600" }}>Hybrid Mobile Application</h4>
                <div className="bd-about-six-text">
                  <div className="bd-section-title-wrapper mb-25">
                    <p style={{ fontSize: "18px", lineHeight: "1.75" }}>
                      Hybrid applications are conveniently available and can be
                      downloaded through both web browsers and app stores.
                      Crafted using JavaScript and HTML5, much like web
                      applications, hybrid apps entail minimal maintenance.
                      While they may not match the speed of native apps, their
                      performance hinges on the swiftness of the browser.
                      Essentially, hybrid apps convert existing website content
                      into an app-like format.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-8 mobile-subpoint-section">
                <div className="bd-about-six-img">
                  <div className="bd-about-six-feature six-feature-mobile pl-120">
                    <h4 className="mb-15" style={{ fontWeight: "600" }}>
                      Key Features
                    </h4>
                    <ul className="">
                      <li
                        style={{
                          fontSize: "18px",
                          color: "var(--clr-body-text)",
                        }}
                      >
                        <i>
                          <FontAwesomeIcon icon={faCheck} />
                        </i>{" "}
                        Adaptable across various platforms
                      </li>
                      <li
                        style={{
                          fontSize: "18px",
                          color: "var(--clr-body-text)",
                        }}
                      >
                        <i>
                          <FontAwesomeIcon icon={faCheck} />
                        </i>
                        No-fuss maintenance
                      </li>
                      <li
                        style={{
                          fontSize: "18px",
                          color: "var(--clr-body-text)",
                        }}
                      >
                        <i>
                          <FontAwesomeIcon icon={faCheck} />
                        </i>
                        Speedy and efficient performance
                      </li>
                      <li
                        style={{
                          fontSize: "18px",
                          color: "var(--clr-body-text)",
                        }}
                      >
                        <i>
                          <FontAwesomeIcon icon={faCheck} />
                        </i>
                        Eye-catching user interface design
                      </li>
                      <li
                        style={{
                          fontSize: "18px",
                          color: "var(--clr-body-text)",
                        }}
                      >
                        <i>
                          <FontAwesomeIcon icon={faCheck} />
                        </i>
                        Reaches out to a vast user base
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Fourth Section */}

      <section className="bd-about-six-area pt-70">
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row">
            <h2 className="bd-section-title mb-15 fourth-sec-tittle">
              For Every Business, a{" "}
              <span style={{ color: "#ffbf1e" }}>Mobile Application </span> Is a
              Key Ingredient{" "}
            </h2>
            <div className="col-lg-6 " style={{ width: "100%" }}>
              <div className="bd-about-six-text">
                <div className="bd-section-title-wrapper ">
                  <div className="bd-about-six-feature">
                    <p
                      style={{
                        fontSize: "20px",
                        fontWeight: "600",
                        marginBottom: "25px",
                      }}
                    >
                      In Canada, there is a plethora of companies offering
                      mobile app development services, making it essential to
                      choose the right one for your business.
                    </p>
                    <ul className="">
                      <li style={{ fontSize: "22px", fontWeight: "600" }}>
                        <i>
                          <FontAwesomeIcon icon={faCheck} />
                        </i>{" "}
                        Do your research{" "}
                      </li>
                      <p className="pb-20 pl-25">
                        When assessing a mobile app development firm in Canada,
                        it's essential to undertake thorough research and
                        thoroughly explore their services. This diligent method
                        will guide you to the perfect company that aligns
                        perfectly with your distinct requirements.
                      </p>

                      <li style={{ fontSize: "22px", fontWeight: "600" }}>
                        <i>
                          <FontAwesomeIcon icon={faCheck} />
                        </i>
                        Look out for features{" "}
                      </li>
                      <p className="pl-25">
                        When seeking a company to craft your mobile application,
                        it's vital to take into account the features that hold
                        significance for your business. These features could
                        encompass customer loyalty, advertising strategies, and
                        customized functionalities tailored to your industry or
                        product.
                      </p>
                      <p className="pl-25">
                        Our primary focus revolves around delivering outstanding
                        customer service and crafting user-friendly
                        applications. We are committed to fully grasping your
                        needs and working in tandem with you to conceive an
                        innovative and successful application.
                      </p>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Fiveth Section */}

      <section className="bd-service-details-area pt-80 pb-80">
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row ">
            <div className="col-lg-8" style={{ width: "100%" }}>
              <div className="bd-service-details1">
                <div className="row pb-10 fifth-responsive-sec">
                  <div className="col-xl-5 col-lg-6 mobile-fifth-sec1">
                    <h5 className="mb-10 fourth-sec-tittle">
                      A Passionate team of tech enthusiasts ready to assist your
                      business
                    </h5>
                    <div className="bd-service-details-feature ">
                      <div>
                        <p style={{ fontSize: "17px" }}>
                          Our team is ready to support you in building a smart
                          and effective mobile application that perfectly suits
                          your business. We excel in designing and developing
                          user-friendly, intuitive apps. With our experienced
                          mobile app developers, your business will not only
                          operate more efficiently but also project a visually
                          appealing presence. Reach out to us today to explore
                          how we can assist you in crafting the perfect mobile
                          app for your business needs.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-6 mobile-fifth-sec2">
                    <div
                      className="bd-service-details-feature-img"
                      style={{ paddingTop: "10px" }}
                    >
                      <img
                        src={section4}
                        alt="img not found"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section
        className="bd-video-area pt-135 pb-130"
        style={{ backgroundColor: "#5c0385" }}
      >
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row responsive-banner">
            <div className="col-lg-12 first_section">
              <div className="bd-video-text">
                <h2 className="bd-video-title first-para-resp">
                  Looking for a Mobile App Development Professional in Canada?
                </h2>
                <p className="contact_section second-para-resp">
                  You're here at the right moment.
                </p>
                <p className="contact_subtext">
                  Outstanding App Development, let's kick start now!
                </p>
              </div>
            </div>
            <div className="col-lg-12 second_section">
              <div className="contact-stuff pt-30">
                <div className="contact_icon icon_respon pt-15 pl-50">
                  <FontAwesomeIcon
                    icon={faPhone}
                    style={{ fontSize: "30px" }}
                  />
                </div>
                <div className="contact_txt ">
                  <p className="contact-sub-text">CALL US NOW</p>
                  <a
                    href="tel:+1 (647) 446-9073"
                    style={{ fontSize: "17px" }}
                    className="mbb-5 pb-20"
                  >
                    +1 (647) 446-9073
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <CanadaFooter />
    </div>
  );
};

export default CanadaMobileApp;
